<template>
    <!-- Modal structure using Bootstrap data attributes -->
    <div
      class="modal fade"
      :id="modalId" 
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
    >
      <div class="modal-dialog modal-dialog-centered custom-modal-two">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header border-0 custom-modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ title }}</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="onCancel"
            ></button>
          </div>
  
          <!-- Modal Body -->
          <div class="modal-body custom-modal-body">
            <slot></slot> <!-- Form content will be injected here -->

            <div class="modal-footer-btn">
                <button type="button" class="btn btn-cancel me-2" data-bs-dismiss="modal" @click="onCancel">{{ $t('cancel') }}</button>
                <button type="submit" class="btn btn-submit" @click="onSubmit">{{ $t('submit') }}</button>
            </div>
          </div>  
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      title: {
        type: String,
        default: 'Create/Edit Category',
      },
      modalId: {
        type: String,
        required: true, 
    },
    },
    methods: {
      onSubmit() {
        this.$emit('submit'); 
      },
      onCancel() {
        this.$emit('cancel');  
      },
    },
  };
  </script>
  
  <style scoped>
  /* Custom Modal Styles */
  

  </style>
  